module.exports = __webpack_public_path__ + "img/waves.91d30977.png";